module.exports = __webpack_public_path__ + "img/back-btn.e91521fc.svg";